import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'skeletor-card',
  standalone: true,
  imports: [CommonModule, SkeletonModule],
  templateUrl: './card.template.component.html',
  styleUrls: ['./card.template.component.scss']
})
export class SkeletorCardTemplateComponent {}

